import { useConfig } from 'providers/config/ConfigProvider';
import { ReactNode } from 'react';
import { FeatureFlags } from 'types';

export const useFeature = (feature: keyof FeatureFlags): boolean => {
  const { featureFlags } = useConfig();
  const isFeatureAllowed = featureFlags[feature];

  return isFeatureAllowed === true;
};

type FeatureToggleRouteProps = {
  component: ReactNode;
  fallback: ReactNode;
  feature: keyof FeatureFlags;
};

export const FeatureToggleRoute = ({
  component,
  fallback,
  feature
}: FeatureToggleRouteProps): JSX.Element => {
  const featureEnabled = useFeature(feature);
  return <>{featureEnabled ? component : fallback}</>;
};
